export default __webpack_public_path__ + "static/media/orangeTriangle.f5f50639.svg";